/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Actor_SomeoneInputs */

const en_live_actor_someone = /** @type {(inputs: Live_Actor_SomeoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`someone`)
};

const de_live_actor_someone = /** @type {(inputs: Live_Actor_SomeoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`jemandem`)
};

/**
* | output |
* | --- |
* | "someone" |
*
* @param {Live_Actor_SomeoneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const live_actor_someone = /** @type {((inputs?: Live_Actor_SomeoneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Actor_SomeoneInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_live_actor_someone(inputs)
	return en_live_actor_someone(inputs)
});